// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Notice from 'sail/Notice';

type InfoItemProps = {|
  id?: string,
  className?: string,
  header: string,
  content: string,
  icon?: string,
|};

export const InfoItem = ({
  id,
  className,
  header,
  content,
  icon,
}: InfoItemProps) => (
  <Box className={classNames('InfoBoxWithCalloutItem', className)} id={id}>
    <Notice
      title={header}
      description={content}
      divider={false}
      // $FlowExpectedError icon wants a specific string but we just have a generic one
      icon={icon || 'info'}
      color="offset"
    />
  </Box>
);
